import React from 'react'
import NavbarSettings from './NavbarSettings';
import {Link} from 'react-router-dom';
import NavbarIconMobile from './NavbarIconMobile';
import NavbarMobileBottom from './NavbarMobileBottom';
import SteamSignIn from './SteamSignIn';

const NavBarNoAuthWeb = () => {
  return (
      <>
        <nav
            className="block lg:hidden fixed top-0 left-0 right-0 transition-all duration-300 z-50 bg-light dark:bg-dark border-b border-neutral-200 dark:border-neutral-700 h-[65px]">
          <div className="flex justify-between px-4 mt-3">
            <Link to="/" className="flex">
              <NavbarIconMobile/>
            </Link>
            <div className="flex items-center space-x-4">
              <SteamSignIn/>
              <NavbarSettings/>
            </div>
          </div>
        </nav>
        <NavbarMobileBottom/>
      </>
  )
}
export default NavBarNoAuthWeb
